export default __webpack_public_path__ + "static/media/img_major01_1.89d3c5fd.jpg";